import currentStateData from './current-state.json'
import {
  createDefaultStandings,
  GROUP_LETTERS,
  type GroupLetter,
  type GroupStandings,
} from './bracket'

type CurrentTournamentState = {
  lastUpdated: string
  summary: string
  groupOrderIds: Record<GroupLetter, string[]>
  completedGroups: GroupLetter[]
  selectedThirdGroups: GroupLetter[]
}

export const CURRENT_TOURNAMENT_STATE =
  currentStateData as CurrentTournamentState

export function createCurrentTournamentStandings(): GroupStandings {
  const defaultStandings = createDefaultStandings()
  const next = { ...defaultStandings }

  for (const group of GROUP_LETTERS) {
    const teamsById = new Map(
      defaultStandings[group].map((team) => [team.id, team]),
    )
    const orderedTeams = CURRENT_TOURNAMENT_STATE.groupOrderIds[group]
      .map((teamId) => teamsById.get(teamId))
      .filter((team): team is NonNullable<typeof team> => Boolean(team))

    if (orderedTeams.length !== defaultStandings[group].length) {
      throw new Error(`Invalid current tournament order for group ${group}`)
    }

    next[group] = orderedTeams.map((team) => ({ ...team }))
  }

  return next
}

export function getCurrentTournamentThirdGroups(): GroupLetter[] {
  return [...CURRENT_TOURNAMENT_STATE.selectedThirdGroups]
}

export function isCurrentTournamentGroupComplete(group: GroupLetter): boolean {
  return CURRENT_TOURNAMENT_STATE.completedGroups.includes(group)
}
